'use strict';

import './editar-tecido';
import './tecido';
import './tecidos.service';

angular
  .module('app')
  .config(($routeProvider) => {
    $routeProvider
      .when('/tecidos', {
        template: '<tecidos>',
      })
      .when('/tecidos/novo', {
        template: '<editar-tecido>',
      })
      .when('/tecidos/:id', {
        template: '<tecido>',
      })
      .when('/tecidos/:id/editar', {
        template: '<editar-tecido>',
      });
  })
  .component('tecidos', {
    templateUrl: 'tecidos.html',
    controller(Fabrics, $location, $filter) {
      this.$onInit = () => {
        this.carregando = true;
        this.tecidos = [];
        this.tecidosVisualizado = [];
        this.tecidosFiltrados = [];
        this.ordenacao = 'name';
        this.query();
      };

      this.query = () => {
        Fabrics.query().then((tecidos) => {
          this.tecidos = $filter('orderBy')(tecidos, this.ordenacao);
          this.carregando = false;
          this.tecidosFiltrados = this.tecidos;
        });
      };

      this.novo = () => {
        $location.path('/tecidos/novo');
      };

      this.exibirFiltros = () => {
        this.exibeFiltros = !this.exibeFiltros;
      };

      this.atualizarFiltros = () => {
        this.tecidosFiltrados = $filter('filter')(this.tecidos, {
          name: this.filtroNome || undefined,
          group: { name: this.filtroGrupo || undefined },
          subgrupo: { name: this.filtroSubgrupo || undefined },
        });
      };

      this.ordenar = () => {
        this.tecidos = $filter('orderBy')(this.tecidos, this.ordenacao);
        this.atualizarFiltros();
      };
    },
  });
